// extracted by mini-css-extract-plugin
export default {"error":"Iframe_error__uJkD1","errorText":"Iframe_errorText__EXjZI","iframe":"Iframe_iframe__eSxXl"};